import { FC, ReactNode, ReactElement, } from 'react';
import classnames from 'classnames';
import {
  LayOutPageProps,
  LayOutPageItemProps,
  LayOutPageItemEnum,
  ILayOutPageInfo,
} from './interface';
import './style.less';
/** 页面布局 */
const LayOutPage: FC<LayOutPageProps> = props => {
  const { children, className, tableId, bodyClassName, bodyStyle, ...restProps } = props;
  const renderChildren = (childrenNodes: ReactNode): ReactElement => {
    const contentInfo: ILayOutPageInfo = {
      left: [],
      lefts: [],
      right: [],
      header: [],
      content: [],
      footer: [],
      detail: null,
    };
    if (Array.isArray(childrenNodes) && childrenNodes.length) {
      childrenNodes.forEach(item => {
        const childElement = item as React.FunctionComponentElement<
          LayOutPageItemProps
        >;
        if (!childElement.type) return null;
        const { displayName } = childElement.type;
        switch (displayName) {
          case LayOutPageItemEnum.Left:
            contentInfo.left.push(item);
            break;
          case LayOutPageItemEnum.Lefts:
            contentInfo.lefts.push(item);
            break;
          case LayOutPageItemEnum.Right:
            contentInfo.right.push(item);
            break;
          case LayOutPageItemEnum.Header:
            contentInfo.header.push(item);
            break;
          case LayOutPageItemEnum.Content:
            contentInfo.content.push(item);
            break;
          case LayOutPageItemEnum.Footer:
            contentInfo.footer.push(item);
            break;
          case LayOutPageItemEnum.Detail:
            contentInfo.detail = item;
            break;
          default:
            return;
        }
      });
    } else {
      if (childrenNodes) return renderChildren([childrenNodes]);
    }
    const classes = classnames(
      'yb-layout-page',
      'yb-layout-page-vertical',
      className,
    );
    const bodyClasses = classnames('yb-layout-page-body', bodyClassName, {
      'yb-layout-page-row': contentInfo.left.length || contentInfo.right.length,
      'yb-layout-page-column': contentInfo.header.length || contentInfo.footer.length,
      'not-box-shadow': contentInfo.lefts.length,
    });
    return (
      <>
        <div className={classes} id={tableId} {...restProps}>
          {contentInfo.left}
          {contentInfo.lefts}
          <div className={bodyClasses} style={bodyStyle}>
            {contentInfo.header}
            {contentInfo.content}
            {contentInfo.footer}
          </div>
          {contentInfo.right}
        </div>
        {contentInfo.detail}
      </>
    );
  };
  return renderChildren(children);
};

export default LayOutPage;
